class ResponseCodes {
  static readonly HTTP_200_OK = 200;
  static readonly HTTP_400_BAD_REQUEST = 400;
  static readonly HTTP_404_NOT_FOUND = 404;
  static readonly ACCESS_FORBIDDEN_FOR_IDENTITY = 54007;
  static readonly LIST_NOT_FOUND = 54150;
}

export { ResponseCodes };